import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import goneawaySuppressionPageData from '../data/servicePages/goneawaySuppression';

const GoneawaySuppressionPage = () => <ServicePageLayout data={goneawaySuppressionPageData} />;

export default GoneawaySuppressionPage;
